import React, { useEffect } from "react";
import styles from "./styles.module.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getStatsDetails } from "../../actions";
import { useLocation } from "react-router-dom";
import { FaRegFaceSadTear } from "react-icons/fa6";
import { Loading } from "../../../../../common/ui";

const CurrentStockDetailsSection = ({
  getStatsDetails,
  stats: { statsDetails, isGetStatsDetailsLoading, isGetStatsDetailsSuccess },
  auth: { branchId, companyId },
}) => {
  const location = useLocation();

  const defaultDetails = {
    valueOfCurrentStock: 0,
    totalExpectedSales: 0,
    totalExpectedProfit: 0,
    outOfStockItemCount: 0,
  };

  const {
    valueOfCurrentStock,
    totalExpectedSales,
    totalExpectedProfit,
    outOfStockItemCount,
  } = statsDetails || defaultDetails;

  const boxesDetails = [
    { id: 1, title: "Value of Current Stocks", value: valueOfCurrentStock },
    { id: 2, title: "Total Expected Sales", value: totalExpectedSales },
    { id: 3, title: "Total Expected Profit", value: totalExpectedProfit },
    { id: 4, title: "Out of Stock Items", value: outOfStockItemCount },
  ];

  useEffect(() => {
    if (branchId && companyId) {
      getStatsDetails(companyId, branchId);
    }
  }, [branchId, companyId, location, getStatsDetails]);

  return (
    <div className={styles.container}>
      <h2 className={styles.sectionHeader}>Current Stock Details</h2>

      {isGetStatsDetailsLoading ? (
        <div className={styles.loadingWrap}>
          <Loading variant="inline" label="" />
        </div>
      ) : isGetStatsDetailsSuccess && statsDetails ? (
        <div className={styles.boxesGrid}>
          {boxesDetails.map((item) => (
            <div key={item.id} className={styles.statCard}>
              <div className={styles.statTitle}>{item.title}</div>
              <div className={styles.statValue}>{item.value}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noData}>
          <FaRegFaceSadTear className={styles.noDataIcon} aria-hidden />
          <p>No stock data available at the moment.</p>
        </div>
      )}
    </div>
  );
};

CurrentStockDetailsSection.propTypes = {
  getStatsDetails: PropTypes.func.isRequired,
  stats: PropTypes.shape({
    statsDetails: PropTypes.object,
    isGetStatsDetailsLoading: PropTypes.bool,
    isGetStatsDetailsSuccess: PropTypes.bool,
  }).isRequired,
  auth: PropTypes.shape({
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
  stats: state.statsState,
});

export default connect(mapStateToProps, {
  getStatsDetails,
})(CurrentStockDetailsSection);
